// extracted by mini-css-extract-plugin
module.exports = {"application-menu":"application-menu___3L6Mb","menu-item":"menu-item___gfSpl","icon":"icon___1CNue","text":"text___25KB6","appsBtn":"appsBtn___1Cu6W","disable":"disable___1LUte"};